import { request } from './request'
// import axios from 'axios'
// import { reject, resolve } from 'core-js/fn/promise'
export const Login = (data) => {
    return request({
        url: '/api/Account/Login',
        method: 'post',
        data
    })
}

export const LoginInfo = () => {
    return request({
        url: '/api/Users/LoginInfo',
        method: 'post'
    })
}

export const RoleListPage = (data) => {
    return request({
        url: '/api/RoleMgr/GetPageRoleList',
        method: 'post',
        data
    })
}
export const DeviceModelsList = () => {
    return request({
        url: '/api/Users/GetDeviceModelsList',
        method: 'get'
    })
}

export const GetMenuTree = () => {
    return request({
        url: 'api/MenuMgr/GetMenuTree',
        method: 'get',
    })
}


export const AddRole = (data) => {
    return request({
        url: '/api/RoleMgr/AddRole',
        method: 'post',
        data
    })
}


export const SearchData = (data) => {
    return request({
        url: '/api/Users/DeviceCUserInfo',
        method: 'post',
        data
    })
}

export const GetRoleDetial = (data) => {
    return request({
        url: '/api/RoleMgr/GetRoleDetial',
        method: 'post',
        data
    })
}


export const EditRole = (data) => {
    return request({
        url: '/api/RoleMgr/EditRole',
        method: 'post',
        data
    })
}

export const DeleteRole = (data) => {
    return request({
        url: '/api/RoleMgr/DeleteRole',
        method: 'post',
        data
    })
}

export const SwitchRoleState = (data) => {
    return request({
        url: '/api/RoleMgr/SwitchRoleState',
        method: 'post',
        data
    })
}

export const GetRoleList = ()=> {
    return request({
        url: '/api/RoleMgr/GetRoleList',
        method: 'get',
    })
}

export const GetUserPageList = (data) => {
    return request({
        url: '/api/CompanyUser/GetUserPageList',
        method: 'post',
        data
    })
}

export const CreateBUser = (data) => {
    return request({
        url: '/api/CompanyUser/AddBUser',
        method: 'post',
        data
    })
}

export const EditBUser = (data) => {
    return request({
        url: '/api/CompanyUser/EditBUser',
        method: 'post',
        data
    })
}

export const ResetPassword = (data) => {
    return request({
        url: '/api/CompanyUser/ResetPassword',
        method: 'post',
        data
    })
}

export const ChangeBUserState = (data) => {
    return request({
        url: '/api/CompanyUser/ChangeUserState',
        method: 'post',
        data
    })
}

export const DeleteBUser = (data) => {
    return request({
        url: '/api/CompanyUser/DeleteBUser',
        method: 'post',
        data
    })
}

export const GetPersonInfoDetial = (data) => {
    return request({
        url: '/api/CompanyUser/GetPersonInfoDetial',
        method: 'post',
        data
    })
}

export const SavePersonInfo = (data) => {
    return request({
        url: '/api/CompanyUser/SavePersonInfo',
        method: 'post',
        data
    })
}

export const UploadUserAvatar = (data) => {
    return request({
        url: '/api/Common/UploadUserAvatar',
        method: 'post',
        data
    })
}

export const CheckUserPwd = (data) => {
    return request({
        url: '/api/CompanyUser/CheckUserPwd',
        method: 'post',
        data
    })
}

export const PersonInfoResetPassword = (data) => {
    return request({
        url: '/api/CompanyUser/PersonInfoResetPassword',
        method: 'post',
        data
    })
}


export const GetRoleExcelData = (data) => {
    return request({
        url: '/api/RoleMgr/GetRoleExcelData',
        method: 'post',
        data
    })
}

export const GetBUserExcelData = (data) => {
    return request({
        url: '/api/CompanyUser/GetBUserExcelData',
        method: 'post',
        data
    })
}

// export const AsyncLoginInfo=()=>{
//     return new Promise(resolve,reject=>{
//         resolve( request({
//             url:'Users/LoginInfo',
//             method:'post'
//         }))
//     })
// }